import { render } from "./currentSituationBoard.vue?vue&type=template&id=ffe119c2&scoped=true"
import script from "./currentSituationBoard.vue?vue&type=script&lang=js"
export * from "./currentSituationBoard.vue?vue&type=script&lang=js"

import "./currentSituationBoard.vue?vue&type=style&index=0&id=ffe119c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe119c2"]])

export default __exports__